/* ------------------------------
   RANDOM SOLD COUNT
--------------------------------*/
(function () {
  const el = document.getElementById("sold-count");
  if (!el) return;

  const min = 10;
  const max = 25;
  const randomSold = Math.floor(Math.random() * (max - min + 1)) + min;

  el.innerText = randomSold;
})();


/* ------------------------------
   VIEWER COUNT (AUTO UPDATE)
--------------------------------*/
(function () {
  const el = document.getElementById("viewer-count");
  if (!el) return;

  function updateViewerCount() {
    const min = 50;
    const max = 300;
    const count = Math.floor(Math.random() * (max - min + 1)) + min;
    el.innerText = count;
  }

  updateViewerCount();
  setInterval(updateViewerCount, 5000);
})();


/* ------------------------------
   TABS FUNCTION
--------------------------------*/
document.addEventListener("click", function (e) {
  const button = e.target.closest(".tab-btn");
  if (!button) return;

  const tab = button.dataset.tab;

  document.querySelectorAll(".tab-btn").forEach(btn => btn.classList.remove("active"));
  document.querySelectorAll(".tab-content").forEach(content => content.classList.remove("active"));

  button.classList.add("active");

  if (tab === "review") {
    const reviewSection = document.querySelector("#judgeme_product_reviews");
    if (reviewSection) {
      reviewSection.scrollIntoView({ behavior: "smooth" });
    }
  } else {
    const target = document.getElementById(tab);
    if (target) target.classList.add("active");
  }
});


/* ------------------------------
   OPEN FILTERS (SAFE)
--------------------------------*/
function openFilters() {
  document.querySelectorAll(".facets__disclosure-vertical").forEach((el) => {

    if (!el.hasAttribute("data-user-toggled")) {
      el.setAttribute("open", true);
    }

    if (!el.hasAttribute("data-event-added")) {
      el.addEventListener("toggle", () => {
        el.setAttribute("data-user-toggled", "true");
      });
      el.setAttribute("data-event-added", "true");
    }

  });
}

document.addEventListener("DOMContentLoaded", openFilters);
document.addEventListener("shopify:section:load", openFilters);


/* ------------------------------
   HEADER SCROLL MENU BG
--------------------------------*/
window.addEventListener("scroll", () => {
  const header = document.querySelector(".shopify-section-header-sticky");
  const menu = document.querySelector("sticky-header");

  if (!header || !menu) return;

  if (window.scrollY === 0) {
    menu.style.background = "";
  } 
  else if (!header.classList.contains("shopify-section-header-hidden")) {
    menu.style.background = "black";
  } 
  else {
    menu.style.background = "";
  }
});

/* ------------------------------

Append Wishlist Button Product page

--------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 1024) {
    setTimeout(() => {
      const wishlist = document.querySelector('.Vtl-WishlistButtonWrapper');
      const quantityInput = document.querySelector('.price-per-item__container quantity-input');

      if (wishlist && quantityInput) {
        quantityInput.insertAdjacentElement('afterend', wishlist);
      }
    }, 500);
  }
});

/* ------------------------------

Append Wishlist Button collection page

--------------------------------*/

// const observer = new MutationObserver(() => {
//   document.querySelectorAll('.product-card-wrapper').forEach((card) => {
//     const wishlist = card.querySelector('.Vtl-WishlistIcon__Wrapper');
//     const quickAdd = card.querySelector('.quick-add.no-js-hidden');

//     if (wishlist && quickAdd && !quickAdd.contains(wishlist)) {
//       quickAdd.appendChild(wishlist);
//     }
//   });
// });

// observer.observe(document.body, { childList: true, subtree: true });
// document.addEventListener("DOMContentLoaded", () => {

//   function moveWishlist() {
//     document.querySelectorAll('.product-card-wrapper').forEach((card) => {

//       const wishlist = card.querySelector('.Vtl-WishlistIcon__Wrapper');
//       const quickAdd = card.querySelector('.quick-add.no-js-hidden');

//       // prevent duplicate append
//       if (
//         wishlist &&
//         quickAdd &&
//         !quickAdd.contains(wishlist)
//       ) {
//         quickAdd.appendChild(wishlist);
//       }

//     });
//   }

//   // Initial run
//   moveWishlist();

//   // Watch for dynamically loaded products
//   const observer = new MutationObserver(() => {
//     moveWishlist();
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

// });